





















































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../../lib/abpbase'
import {
	GetWaterMachineMaintainList,
	InsertWaterMachineMaintain,
	UpdateWaterMachineMaintainById,
	DeleteWaterMachineMaintain
} from '../../../../api/engineer'

@Component
export default class EditRole extends AbpBase {
	@Prop({type: Boolean, default: false}) value: boolean;
	@Prop({type: Object, default: {}}) data: object;
	addDialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	addModalShow = false
	dialogFormLabelWidth = '100px'
	tableLoading = false
	tableData = []
	page = 1
	tableTotalSize = 0

	get dialogTitle() {
		return this.data.waterMachineName + "保养记录"
	}

	add() {
		this.addDialogTitle = "新增消毒记录"
		this.dialogForm = {
			machineID: this.data.id
		}
		this.addModalShow = true
	}

	edit(row: any) {
		this.addDialogTitle = "编辑消毒记录"
		this.dialogForm = Object.assign({}, row)
		this.addModalShow = true
	}

	del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteWaterMachineMaintain({Id: row.id})
			this.getData()
		}).catch(() => {

		});
	}

	//新增编辑窗口确认
	async confirm() {
		this.dialogForm.waterMachineID = this.data.id
		if (this.addDialogTitle === "新增消毒记录") {
			let res = await InsertWaterMachineMaintain(this.dialogForm)
		} else {
			let res = await UpdateWaterMachineMaintainById(this.dialogForm)
		}
		this.getData()
	}

	created() {
		this.getData()
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}

	addModalVisibleChange(value: boolean) {
		if (!value) {
			this.addModalShow = false
		}
	}

	async getData() {
		this.tableLoading = true
		let res = await GetWaterMachineMaintainList({
			WaterMachineID: this.data.id,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	rules = {}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/waterTreatment/parts/maintenance.vue